import {
  CREATE_REGISTRY_DELEGATE,
  CREATE_REGISTRY_DELEGATE_FAIL,
  CREATE_REGISTRY_DELEGATE_SUCCESS,
  CREATE_REGISTRY_INVOICES,
  CREATE_REGISTRY_INVOICES_FAIL,
  CREATE_REGISTRY_INVOICES_SUCCESS,
  CREATE_REQUEST_INVOICE_CODE,
  CREATE_REQUEST_INVOICE_CODE_FAIL,
  CREATE_REQUEST_INVOICE_CODE_SUCCESS,
  DOWNLOAD_XML_REGISTRY_DELEGATE,
  DOWNLOAD_XML_REGISTRY_DELEGATE_FAIL,
  DOWNLOAD_XML_REGISTRY_DELEGATE_SUCCESS,
  DOWNLOAD_XML_REGISTRY_INVOICES,
  DOWNLOAD_XML_REGISTRY_INVOICES_FAIL,
  DOWNLOAD_XML_REGISTRY_INVOICES_SUCCESS,
  DOWNLOAD_XML_REQUEST_INVOICE_CODE,
  DOWNLOAD_XML_REQUEST_INVOICE_CODE_FAIL,
  DOWNLOAD_XML_REQUEST_INVOICE_CODE_SUCCESS,
  EDIT_REGISTRY_DELEGATE,
  EDIT_REGISTRY_DELEGATE_FAIL,
  EDIT_REGISTRY_DELEGATE_SUCCESS,
  EDIT_REGISTRY_INVOICES,
  EDIT_REGISTRY_INVOICES_FAIL,
  EDIT_REGISTRY_INVOICES_SUCCESS,
  EDIT_REQUEST_INVOICE_CODE,
  EDIT_REQUEST_INVOICE_CODE_FAIL,
  EDIT_REQUEST_INVOICE_CODE_SUCCESS,
  GET_DETAIL_REGISTRY_DELEGATE,
  GET_DETAIL_REGISTRY_DELEGATE_FAIL,
  GET_DETAIL_REGISTRY_DELEGATE_SUCCESS,
  GET_DETAIL_REGISTRY_INVOICES,
  GET_DETAIL_REGISTRY_INVOICES_FAIL,
  GET_DETAIL_REGISTRY_INVOICES_SUCCESS,
  GET_DETAIL_REQUEST_INVOICE_CODE,
  GET_DETAIL_REQUEST_INVOICE_CODE_FAIL,
  GET_DETAIL_REQUEST_INVOICE_CODE_SUCCESS,
  CHECK_INVOICES_CURRENT,
  CHECK_INVOICES_CURRENT_SUCCESS,
  CHECK_INVOICES_CURRENT_FAIL,
  RESET_CHECK_INVOICES_CURRENT,
  GET_HISTORY_TRANSFER,
  GET_HISTORY_TRANSFER_FAIL,
  GET_HISTORY_TRANSFER_SUCCESS,
  GET_LIST_REGISTRY_DELEGATE,
  GET_LIST_REGISTRY_DELEGATE_FAIL,
  GET_LIST_REGISTRY_DELEGATE_SUCCESS,
  GET_LIST_REGISTRY_INVOICES,
  GET_LIST_REGISTRY_INVOICES_FAIL,
  GET_LIST_REGISTRY_INVOICES_SUCCESS,
  GET_LIST_REQUEST_INVOICE_CODE,
  GET_LIST_REQUEST_INVOICE_CODE_FAIL,
  GET_LIST_REQUEST_INVOICE_CODE_SUCCESS,
  GET_REASON_DENY_RELEASE,
  GET_REASON_DENY_RELEASE_FAIL,
  GET_REASON_DENY_RELEASE_SUCCESS,
  PREVIEW_PDF,
  PREVIEW_PDF_FAIL,
  PREVIEW_PDF_SUCCESS,
  RELEASE_REGISTRY_DELEGATE,
  RELEASE_REGISTRY_DELEGATE_FAIL,
  RELEASE_REGISTRY_DELEGATE_SUCCESS,
  RELEASE_REGISTRY_INVOICES,
  RELEASE_REGISTRY_INVOICES_FAIL,
  RELEASE_REGISTRY_INVOICES_SUCCESS,
  RELEASE_REQUEST_INVOICE_CODE,
  RELEASE_REQUEST_INVOICE_CODE_FAIL,
  RELEASE_REQUEST_INVOICE_CODE_SUCCESS,
  RESET_CREATE_REGISTRY_DELEGATE,
  RESET_CREATE_REGISTRY_INVOICES,
  RESET_CREATE_REQUEST_INVOICE_CODE,
  RESET_DOWNLOAD_XML_REGISTRY_DELEGATE,
  RESET_DOWNLOAD_XML_REGISTRY_INVOICES,
  RESET_DOWNLOAD_XML_REQUEST_INVOICE_CODE,
  RESET_EDIT_REGISTRY_DELEGATE,
  RESET_EDIT_REGISTRY_INVOICES,
  RESET_EDIT_REQUEST_INVOICE_CODE,
  RESET_GET_HISTORY_TRANSFER,
  RESET_GET_REASON_DENY_RELEASE,
  RESET_LIST_REGISTRY_DELEGATE,
  RESET_LIST_REGISTRY_INVOICES,
  RESET_LIST_REQUEST_INVOICE_CODE,
  RESET_PREVIEW_FILE,
  RESET_RELEASE_REGISTRY_DELEGATE,
  RESET_RELEASE_REGISTRY_INVOICES,
  RESET_RELEASE_REQUEST_INVOICE_CODE,
  RESET_TRANSFER_USB,
  SET_COLUMN_VISIBLE_REGISTRY_DELEGATE,
  SET_COLUMN_VISIBLE_REGISTRY_INVOICES,
  SET_COLUMN_VISIBLE_REQUEST_INVOICE_CODE,
  TRANSFER_USB,
  TRANSFER_USB_FAIL,
  TRANSFER_USB_SUCCESS,
  PREVIEW_PDF_REGISTER_INVOICE,
  PREVIEW_PDF_REGISTER_INVOICE_SUCCESS,
  PREVIEW_PDF_REGISTER_INVOICE_FAIL,
  RESET_PREVIEW_PDF_REGISTER_INVOICE,
  DOWNLOAD_PDF_REGISTRY_INVOICES,
  DOWNLOAD_PDF_REGISTRY_INVOICES_SUCCESS,
  DOWNLOAD_PDF_REGISTRY_INVOICES_FAIL,
  RESET_DOWNLOAD_PDF_REGISTRY_INVOICES,
} from "./actionTypes";

const INIT_STATE = {
  type: null,
  // Đăng ký sử dụng
  registryInvoices: {
    params: {
      sizePerPage: 10,
      page: 1,
      sort: "-checker_date",
      columnFilter: {}, // Column filter
      keywords: "", // Input search all
    },
    loading: false,
    listData: [],
    totalCount: 0,
    columnsVisible: {},
  },
  detailRegistryInvoices: {
    loading: false,
    data: null,
    error: null,
  },
  createRegistryInvoices: {
    loading: false,
    data: null,
    error: null,
  },
  editRegistryInvoices: {
    loading: false,
    data: null,
    error: null,
  },
  releaseRegistryInvoices: {
    loading: false,
    data: null,
    error: null,
  },
  // Ủy quyền lập hóa đơn
  registryDelegate: {
    params: {
      sizePerPage: 10,
      page: 1,
      sort: "-checker_date",
      columnFilter: {}, // Column filter
      keywords: "", // Input search all
    },
    loading: false,
    listData: [],
    totalCount: 0,
    columnsVisible: {},
  },
  detailRegistryDelegate: {
    loading: false,
    data: null,
    error: null,
  },
  createRegistryDelegate: {
    loading: false,
    data: null,
    error: null,
  },
  editRegistryDelegate: {
    loading: false,
    data: null,
    error: null,
  },
  releaseRegistryDelegate: {
    loading: false,
    data: null,
    error: null,
  },
  // Đề nghị cấp HDDT có mã
  requestInvoiceCode: {
    params: {
      sizePerPage: 10,
      page: 1,
      sort: "-checker_date",
      columnFilter: {}, // Column filter
      keywords: "", // Input search all
    },
    loading: false,
    listData: [],
    totalCount: 0,
    columnsVisible: {},
  },
  detailRequestInvoiceCode: {
    loading: false,
    data: null,
    error: null,
  },
  createRequestInvoiceCode: {
    loading: false,
    data: null,
    error: null,
  },
  editRequestInvoiceCode: {
    loading: false,
    data: null,
    error: null,
  },
  releaseRequestInvoiceCode: {
    loading: false,
    data: null,
    error: null,
  },
  //
  previewPdfFile: {
    data: null,
    error: null,
    loading: false,
  },
  // Download
  fileDownload: null,
  fileDownloadResponse: null,
  fileDownloadName: null,
  previewPdfRegisterFile: {
    data: null,
    typePreview: null,
    error: null,
    loading: false,
  },
  error: null,
  // send usb xml sign
  transferUSB: {
    data: null,
    error: null,
    loading: false,
  },
  checkInvoiceCurrent: {
    data: null,
    error: null,
    loading: false,
  },
  // Lý do từ chối phát hành
  reasonDenyRelease: {
    data: null,
    error: null,
    loading: false,
  },
  // History
  historyTransfer: {
    data: null,
    error: null,
    loading: false,
  },
};

const dataFormat = (state = INIT_STATE, action) => {
  const curRegistryInvoices = state.registryInvoices;
  const curRegistryDelegate = state.registryDelegate;
  const curRequestInvoiceCode = state.requestInvoiceCode;
  const curDetail = state.detail;
  switch (action.type) {
    // PREVIEW_PDF
    case PREVIEW_PDF_REGISTER_INVOICE:
      return {
        ...state,
        previewPdfRegisterFile: {
          data: null,
          typePreview: null,
          loading: true,
          error: null,
        },
      };
    case PREVIEW_PDF_REGISTER_INVOICE_SUCCESS:
      return {
        ...state,
        previewPdfRegisterFile: {
          data: action.data.url,
          typePreview: action.data.typePreview,
          loading: false,
          error: null,
        },
      };
    case PREVIEW_PDF_REGISTER_INVOICE_FAIL:
      return {
        ...state,
        previewPdfRegisterFile: {
          data: null,
          typePreview: null,
          loading: false,
          error: action.error,
        },
      };
    case RESET_PREVIEW_PDF_REGISTER_INVOICE:
      return {
        ...state,
        previewPdfRegisterFile: {
          data: null,
          typePreview: null,
          loading: false,
          error: null,
        },
      };
    // Đăng ký sử dụng
    case GET_LIST_REGISTRY_INVOICES:
      return {
        ...state,
        registryInvoices: {
          ...curRegistryInvoices,
          loading: true,
          //   params: action.params,
        },
      };
    case GET_LIST_REGISTRY_INVOICES_SUCCESS:
      return {
        ...state,
        registryInvoices: {
          ...curRegistryInvoices,
          loading: false,
          listData: action.listData,
          totalCount: action.totalCount,
        },
      };

    case GET_LIST_REGISTRY_INVOICES_FAIL:
      return {
        ...state,
        registryInvoices: {
          ...curRegistryInvoices,
          loading: false,
          listData: [],
          totalCount: 0,
        },
        error: action.error,
      };
    case RESET_LIST_REGISTRY_INVOICES:
      return {
        ...state,
        registryInvoices: {
          ...curRegistryInvoices,
          loading: false,
          params: {
            sizePerPage: 10,
            page: 1,
            sort: "-checker_date",
            columnFilter: {},
            keywords: "",
          },
          listData: [],
          totalCount: 0,
        },
        type: action.type,
      };
    // Detail Đăng ký sử dụng
    case GET_DETAIL_REGISTRY_INVOICES:
      return {
        ...state,
        detailRegistryInvoices: {
          loading: true,
          data: null,
          error: null,
        },
      };
    case GET_DETAIL_REGISTRY_INVOICES_SUCCESS:
      return {
        ...state,
        detailRegistryInvoices: {
          loading: false,
          data: action.data,
          error: null,
        },
      };

    case GET_DETAIL_REGISTRY_INVOICES_FAIL:
      return {
        ...state,
        detailRegistryInvoices: {
          loading: false,
          data: null,
          error: action.error,
        },
      };
    // Ủy quyền lập hóa đơn
    case GET_LIST_REGISTRY_DELEGATE:
      return {
        ...state,
        registryDelegate: {
          ...curRegistryDelegate,
          loading: true,
          //   params: action.params,
        },
      };
    case GET_LIST_REGISTRY_DELEGATE_SUCCESS:
      return {
        ...state,
        registryDelegate: {
          ...curRegistryDelegate,
          loading: false,
          listData: action.listData,
          totalCount: action.totalCount,
        },
      };

    case GET_LIST_REGISTRY_DELEGATE_FAIL:
      return {
        ...state,
        registryDelegate: {
          ...curRegistryDelegate,
          loading: false,
          listData: [],
          totalCount: 0,
        },
        error: action.error,
      };
    case RESET_LIST_REGISTRY_DELEGATE:
      return {
        ...state,
        registryDelegate: {
          ...curRegistryDelegate,
          loading: false,
          params: {
            sizePerPage: 10,
            page: 1,
            sort: "-checker_date",
            columnFilter: {},
            keywords: "",
          },
          listData: [],
          totalCount: 0,
        },
        type: action.type,
      };
    // Detail Ủy quyền lập hóa đơn
    case GET_DETAIL_REGISTRY_DELEGATE:
      return {
        ...state,
        detailRegistryDelegate: {
          loading: true,
          data: null,
          error: null,
        },
      };
    case GET_DETAIL_REGISTRY_DELEGATE_SUCCESS:
      return {
        ...state,
        detailRegistryDelegate: {
          loading: false,
          data: action.data,
          error: null,
        },
      };

    case GET_DETAIL_REGISTRY_DELEGATE_FAIL:
      return {
        ...state,
        detailRegistryDelegate: {
          loading: false,
          data: null,
          error: action.error,
        },
      };
    // Đề nghị cấp HDDT có mã
    case GET_LIST_REQUEST_INVOICE_CODE:
      return {
        ...state,
        requestInvoiceCode: {
          ...curRequestInvoiceCode,
          loading: true,
          //   params: action.params,
        },
      };
    case GET_LIST_REQUEST_INVOICE_CODE_SUCCESS:
      return {
        ...state,
        requestInvoiceCode: {
          ...curRequestInvoiceCode,
          loading: false,
          listData: action.listData,
          totalCount: action.totalCount,
        },
      };

    case GET_LIST_REQUEST_INVOICE_CODE_FAIL:
      return {
        ...state,
        requestInvoiceCode: {
          ...curRequestInvoiceCode,
          loading: false,
          listData: [],
          totalCount: 0,
        },
        error: action.error,
      };
    case RESET_LIST_REQUEST_INVOICE_CODE:
      return {
        ...state,
        requestInvoiceCode: {
          ...curRequestInvoiceCode,
          loading: false,
          params: {
            sizePerPage: 10,
            page: 1,
            sort: "-checker_date",
            columnFilter: {},
            keywords: "",
          },
          listData: [],
          totalCount: 0,
        },
        type: action.type,
      };
    // Detail Đề nghị cấp HDDT có mã
    case GET_DETAIL_REQUEST_INVOICE_CODE:
      return {
        ...state,
        detailRequestInvoiceCode: {
          loading: true,
          data: null,
          error: null,
        },
      };
    case GET_DETAIL_REQUEST_INVOICE_CODE_SUCCESS:
      return {
        ...state,
        detailRequestInvoiceCode: {
          loading: false,
          data: action.data,
          error: null,
        },
      };
    case GET_DETAIL_REQUEST_INVOICE_CODE_FAIL:
      return {
        ...state,
        detailRequestInvoiceCode: {
          loading: false,
          data: null,
          error: action.error,
        },
      };
    // Tạo đăng ký sử sụng
    case CREATE_REGISTRY_INVOICES:
      return {
        ...state,
        createRegistryInvoices: {
          loading: true,
          data: null,
          error: null,
        },
      };
    case CREATE_REGISTRY_INVOICES_SUCCESS:
      return {
        ...state,
        createRegistryInvoices: {
          loading: false,
          data: action.data,
          error: null,
        },
        type: action.type,
      };

    case CREATE_REGISTRY_INVOICES_FAIL:
      return {
        ...state,
        createRegistryInvoices: {
          loading: false,
          data: null,
          error: action.error,
        },
        type: action.type,
      };
    case RESET_CREATE_REGISTRY_INVOICES:
      return {
        ...state,
        createRegistryInvoices: {
          loading: false,
          data: null,
          error: null,
        },
        type: action.type,
      };
    // Cập nhật đăng ký sử sụng
    case EDIT_REGISTRY_INVOICES:
      return {
        ...state,
        editRegistryInvoices: {
          loading: true,
          data: null,
          error: null,
        },
      };
    case EDIT_REGISTRY_INVOICES_SUCCESS:
      return {
        ...state,
        editRegistryInvoices: {
          loading: false,
          data: action.data,
          error: null,
        },
        type: action.type,
      };

    case EDIT_REGISTRY_INVOICES_FAIL:
      return {
        ...state,
        editRegistryInvoices: {
          loading: false,
          data: null,
          error: action.error,
        },
        type: action.type,
      };
    case RESET_EDIT_REGISTRY_INVOICES:
      return {
        ...state,
        editRegistryInvoices: {
          loading: false,
          data: null,
          error: null,
        },
        type: action.type,
      };

    // Tạo Ủy quyền lập hóa đợn
    case CREATE_REGISTRY_DELEGATE:
      return {
        ...state,
        createRegistryDelegate: {
          loading: true,
          data: null,
          error: null,
        },
      };
    case CREATE_REGISTRY_DELEGATE_SUCCESS:
      return {
        ...state,
        createRegistryDelegate: {
          loading: false,
          data: action.data,
          error: null,
        },
        type: action.type,
      };

    case CREATE_REGISTRY_DELEGATE_FAIL:
      return {
        ...state,
        createRegistryDelegate: {
          loading: false,
          data: null,
          error: action.error,
        },
        type: action.type,
      };
    case RESET_CREATE_REGISTRY_DELEGATE:
      return {
        ...state,
        createRegistryDelegate: {
          loading: false,
          data: null,
          error: null,
        },
        type: action.type,
      };
    // Cập nhật Ủy quyền lập hóa đợn
    case EDIT_REGISTRY_DELEGATE:
      return {
        ...state,
        editRegistryDelegate: {
          loading: true,
          data: null,
          error: null,
        },
      };
    case EDIT_REGISTRY_DELEGATE_SUCCESS:
      return {
        ...state,
        editRegistryDelegate: {
          loading: false,
          data: action.data,
          error: null,
        },
        type: action.type,
      };

    case EDIT_REGISTRY_DELEGATE_FAIL:
      return {
        ...state,
        editRegistryDelegate: {
          loading: false,
          data: null,
          error: action.error,
        },
        type: action.type,
      };
    case RESET_EDIT_REGISTRY_DELEGATE:
      return {
        ...state,
        editRegistryDelegate: {
          loading: false,
          data: null,
          error: null,
        },
        type: action.type,
      };

    // Tạo Đề nghị cấp HDDT có mã
    case CREATE_REQUEST_INVOICE_CODE:
      return {
        ...state,
        createRequestInvoiceCode: {
          loading: true,
          data: null,
          error: null,
        },
      };
    case CREATE_REQUEST_INVOICE_CODE_SUCCESS:
      return {
        ...state,
        createRequestInvoiceCode: {
          loading: false,
          data: action.data,
          error: null,
        },
        type: action.type,
      };

    case CREATE_REQUEST_INVOICE_CODE_FAIL:
      return {
        ...state,
        createRequestInvoiceCode: {
          loading: false,
          data: null,
          error: action.error,
        },
        type: action.type,
      };
    case RESET_CREATE_REQUEST_INVOICE_CODE:
      return {
        ...state,
        createRequestInvoiceCode: {
          loading: false,
          data: null,
          error: null,
        },
        type: action.type,
      };
    // Cập nhật Đề nghị cấp HDDT có mã
    case EDIT_REQUEST_INVOICE_CODE:
      return {
        ...state,
        editRequestInvoiceCode: {
          loading: true,
          data: null,
          error: null,
        },
      };
    case EDIT_REQUEST_INVOICE_CODE_SUCCESS:
      return {
        ...state,
        editRequestInvoiceCode: {
          loading: false,
          data: action.data,
          error: null,
        },
        type: action.type,
      };

    case EDIT_REQUEST_INVOICE_CODE_FAIL:
      return {
        ...state,
        editRequestInvoiceCode: {
          loading: false,
          data: null,
          error: action.error,
        },
        type: action.type,
      };
    case RESET_EDIT_REQUEST_INVOICE_CODE:
      return {
        ...state,
        editRequestInvoiceCode: {
          loading: false,
          data: null,
          error: null,
        },
        type: action.type,
      };
    // Phát hành tờ khai đăng ký sử dụng
    case RELEASE_REGISTRY_INVOICES:
      return {
        ...state,
        releaseRegistryInvoices: {
          loading: true,
          data: null,
          error: null,
        },
      };
    case RELEASE_REGISTRY_INVOICES_SUCCESS:
      return {
        ...state,
        releaseRegistryInvoices: {
          loading: false,
          data: null,
          error: null,
        },
        type: action.type,
      };

    case RELEASE_REGISTRY_INVOICES_FAIL:
      return {
        ...state,
        releaseRegistryInvoices: {
          loading: false,
          data: null,
          error: action.error,
        },
        type: action.type,
      };
    case RESET_RELEASE_REGISTRY_INVOICES:
      return {
        ...state,
        releaseRegistryInvoices: {
          loading: false,
          data: null,
          error: action.error,
        },
        type: action.type,
      };
    // Phát hành Ủy quyền lập hóa đơn
    case RELEASE_REGISTRY_DELEGATE:
      return {
        ...state,
        releaseRegistryDelegate: {
          loading: true,
          data: null,
          error: null,
        },
      };
    case RELEASE_REGISTRY_DELEGATE_SUCCESS:
      return {
        ...state,
        releaseRegistryDelegate: {
          loading: false,
          data: null,
          error: null,
        },
        type: action.type,
      };

    case RELEASE_REGISTRY_DELEGATE_FAIL:
      return {
        ...state,
        releaseRegistryDelegate: {
          loading: false,
          data: null,
          error: action.error,
        },
        type: action.type,
      };
    case RESET_RELEASE_REGISTRY_DELEGATE:
      return {
        ...state,
        releaseRegistryDelegate: {
          loading: false,
          data: null,
          error: action.error,
        },
        type: action.type,
      };
    // Phát hành ĐỀ NGHỊ CẤP HDDT CÓ MÃ
    case RELEASE_REQUEST_INVOICE_CODE:
      return {
        ...state,
        releaseRequestInvoiceCode: {
          loading: true,
          data: null,
          error: null,
        },
      };
    case RELEASE_REQUEST_INVOICE_CODE_SUCCESS:
      return {
        ...state,
        releaseRequestInvoiceCode: {
          loading: false,
          data: null,
          error: null,
        },
        type: action.type,
      };

    case RELEASE_REQUEST_INVOICE_CODE_FAIL:
      return {
        ...state,
        releaseRequestInvoiceCode: {
          loading: false,
          data: null,
          error: action.error,
        },
        type: action.type,
      };
    case RESET_RELEASE_REQUEST_INVOICE_CODE:
      return {
        ...state,
        releaseRequestInvoiceCode: {
          loading: false,
          data: null,
          error: action.error,
        },
        type: action.type,
      };
    // Action Download
    case DOWNLOAD_XML_REGISTRY_INVOICES:
    case DOWNLOAD_XML_REGISTRY_DELEGATE:
    case DOWNLOAD_PDF_REGISTRY_INVOICES:
    case DOWNLOAD_XML_REQUEST_INVOICE_CODE:
      return {
        ...state,
        type: action.type,
        fileDownload: null,
        fileDownloadResponse: null,
        fileDownloadName: null,
        error: action.error,
      };
    case DOWNLOAD_XML_REGISTRY_INVOICES_SUCCESS:
    case DOWNLOAD_XML_REGISTRY_DELEGATE_SUCCESS:
    case DOWNLOAD_PDF_REGISTRY_INVOICES_SUCCESS:
    case DOWNLOAD_XML_REQUEST_INVOICE_CODE_SUCCESS:
      return {
        ...state,
        type: action.type,
        fileDownload: action.fileDownload,
        fileDownloadResponse: action.fileDownloadResponse,
        fileDownloadName: action.fileDownloadName,
      };
    case DOWNLOAD_XML_REGISTRY_INVOICES_FAIL:
    case DOWNLOAD_XML_REGISTRY_DELEGATE_FAIL:
    case DOWNLOAD_PDF_REGISTRY_INVOICES_FAIL:
    case DOWNLOAD_XML_REQUEST_INVOICE_CODE_FAIL:
      return {
        ...state,
        type: action.type,
        fileDownload: null,
        fileDownloadResponse: null,
        fileDownloadName: null,
        error: action.error,
      };
    case RESET_DOWNLOAD_XML_REGISTRY_INVOICES:
    case RESET_DOWNLOAD_XML_REGISTRY_DELEGATE:
    case RESET_DOWNLOAD_PDF_REGISTRY_INVOICES:
    case RESET_DOWNLOAD_XML_REQUEST_INVOICE_CODE:
      return {
        ...state,
        type: null,
        error: null,
        // fileDownload: null,
        // fileDownloadResponse: null,
        // fileDownloadName: null,
      };
    //PREVIEW_PDF
    case PREVIEW_PDF:
      return {
        ...state,
        previewPdfFile: {
          data: null,
          loading: true,
          error: null,
        },
      };
    case PREVIEW_PDF_SUCCESS:
      return {
        ...state,
        previewPdfFile: {
          data: action.data,
          loading: false,
          error: null,
        },
      };
    case PREVIEW_PDF_FAIL:
      return {
        ...state,
        previewPdfFile: {
          data: null,
          loading: false,
          error: action.error,
        },
      };
    case RESET_PREVIEW_FILE:
      return {
        ...state,
        previewPdfFile: {
          data: null,
          loading: false,
          error: null,
        },
      };
    //
    // TRANSFER_USB
    case TRANSFER_USB:
      return {
        ...state,
        transferUSB: {
          data: null,
          error: null,
          loading: true,
        },
      };
    case TRANSFER_USB_SUCCESS:
      return {
        ...state,
        type: action.type,
        transferUSB: {
          data: null,
          error: null,
          loading: false,
        },
      };

    case TRANSFER_USB_FAIL:
      return {
        ...state,
        type: action.type,
        transferUSB: {
          data: null,
          error: action.error,
          loading: false,
        },
      };
    case RESET_TRANSFER_USB:
      return {
        ...state,
        type: action.type,
        transferUSB: {
          data: null,
          error: null,
          loading: false,
        },
      };
    //GET_REASON_DENY_RELEASE
    case GET_REASON_DENY_RELEASE:
      return {
        ...state,
        reasonDenyRelease: {
          data: null,
          error: null,
          loading: true,
        },
      };
    case GET_REASON_DENY_RELEASE_SUCCESS:
      return {
        ...state,
        type: action.type,
        reasonDenyRelease: {
          data: action.data,
          error: null,
          loading: false,
        },
      };

    case GET_REASON_DENY_RELEASE_FAIL:
      return {
        ...state,
        type: action.type,
        reasonDenyRelease: {
          data: null,
          error: null,
          loading: false,
        },
      };
    case RESET_GET_REASON_DENY_RELEASE:
      return {
        ...state,
        type: action.type,
        reasonDenyRelease: {
          data: null,
          error: null,
          loading: false,
        },
      };

    //CHECK_INVOICES_CURRENT
    case CHECK_INVOICES_CURRENT:
      return {
        ...state,
        checkInvoiceCurrent: {
          data: null,
          error: null,
          loading: true,
        },
      };
    case CHECK_INVOICES_CURRENT_SUCCESS:
      return {
        ...state,
        type: action.type,
        checkInvoiceCurrent: {
          data: action.data,
          error: null,
          loading: false,
        },
      };
    case CHECK_INVOICES_CURRENT_FAIL:
      return {
        ...state,
        checkInvoiceCurrent: {
          data: null,
          error: null,
          loading: true,
        },
      };
    case RESET_CHECK_INVOICES_CURRENT:
      return {
        ...state,
        checkInvoiceCurrent: {
          data: null,
          error: null,
          loading: true,
        },
      };

    //GET_HISTORY_TRANSFER
    case GET_HISTORY_TRANSFER:
      return {
        ...state,
        historyTransfer: {
          data: null,
          error: null,
          loading: true,
        },
      };
    case GET_HISTORY_TRANSFER_SUCCESS:
      return {
        ...state,
        type: action.type,
        historyTransfer: {
          data: action.data,
          error: null,
          loading: false,
        },
      };

    case GET_HISTORY_TRANSFER_FAIL:
      return {
        ...state,
        type: action.type,
        historyTransfer: {
          data: null,
          error: null,
          loading: false,
        },
      };
    case RESET_GET_HISTORY_TRANSFER:
      return {
        ...state,
        type: action.type,
        historyTransfer: {
          data: null,
          error: null,
          loading: false,
        },
      };

    // Set column
    case SET_COLUMN_VISIBLE_REGISTRY_INVOICES:
      curRegistryInvoices.columnsVisible[action.field] = action.value;
      return {
        ...state,
        registryInvoices: {
          ...curRegistryInvoices,
        },
      };
    case SET_COLUMN_VISIBLE_REGISTRY_DELEGATE:
      curRegistryDelegate.columnsVisible[action.field] = action.value;
      return {
        ...state,
        registryDelegate: {
          ...curRegistryDelegate,
        },
      };
    case SET_COLUMN_VISIBLE_REQUEST_INVOICE_CODE:
      curRequestInvoiceCode.columnsVisible[action.field] = action.value;
      return {
        ...state,
        requestInvoiceCode: {
          ...curRequestInvoiceCode,
        },
      };
    default:
      return state;
  }
};

export default dataFormat;
